import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    background: theme.palette.grey[600],
    height: 30
  },
  subTitles: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    background: theme.palette.grey[100],
    borderRight: `1px dashed ${theme.palette.grey[900]}`,
    minWidth: 120,
    width: '100%'
  },
  subTitlesEven: {
    background: theme.palette.grey[300]
  },
  lastSubTitle: {
    borderRight: 'none'
  },
  connect: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12
  },
  checkIcon: {
    fontSize: 16,
    color: theme.palette.success.main
  },
  clearIcon: {
    fontSize: 16,
    color: theme.palette.primary.main
  },
  we: {
    background: 'pink'
  }
}))

export default useStyles
